import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    
    baseUrl: string;

    constructor(
        private http: HttpClient
    ) { 
        this.baseUrl = environment.apiUrl;
    }

    getToken(cod_sistema: string, auth_string: string) {
        const headers = new HttpHeaders({
            'cod_sistema': cod_sistema,
            'auth_string': auth_string
        });
        return this.http.get(this.baseUrl + '/get/token', {headers: headers, responseType: 'text'});
    }

    checkToken(token: string, auth_string: string) {
        const headers = new HttpHeaders({
            'auth_string': auth_string
        });
        return this.http.get(this.baseUrl + `/check/token/${token}`, {headers: headers});
    }
}